export const RenderingContainerType = {
  CONTACTS: 'CONTACTS',
  TEXT_SMS: 'TEXT_SMS',
  KEYPAD: 'KEYPAD',
  HISTORY: 'HISTORY',
  CHAT: 'CHAT',
  INTERNAL_CHAT: 'INTERNAL_CHAT',
  RECORDINGS: 'RECORDINGS',
  VOICEMAILS: 'VOICEMAILS',
};

export const UserStatus = {
  AVAILABLE: 'Available',
  OUT_OF_OFFICE: 'OutOfOffice',
  UNAVAILABLE: 'Unavailable',
  ON_CALL: 'OnCall',
  LEAD_QUIET_TIME: 'LeadQuietTime',
};

export const UserStatusLabels = {
  [UserStatus.AVAILABLE]: 'Available',
  [UserStatus.OUT_OF_OFFICE]: 'Out of office',
  [UserStatus.UNAVAILABLE]: 'Unavailable',
  [UserStatus.ON_CALL]: 'On call',
  [UserStatus.LEAD_QUIET_TIME]: 'Lead quiet time',
};

export const TelnyxCallState = {
  NEW: 'new',
  TRYING: 'trying',
  REQUESTING: 'requesting',
  EARLY: 'early',
  RINGING: 'ringing',
  ACTIVE: 'active',
  HANGUP: 'hangup',
  DESTROY: 'destroy',
};

export const CallStatus = {
  IDLE: 'idle',
  OUTGOING: 'outgoing',
  INCOMING: 'incoming',
  ACTIVE: 'active',
  POST_CALL: 'post_call',
};

export const TelnyxEvent = {
  NOTIFICATION: 'telnyx.notification',
  ERROR: 'telnyx.error',
  READY: 'telnyx.ready',
  SOCKET_OPEN: 'telnyx.socket.open',
  SOCKET_CLOSE: 'telnyx.socket.close',
  SOCKET_ERROR: 'telnyx.socket.error',
  SOCKET_MESSAGE: 'telnyx.socket.message',
};

export const TelnyxNotificationType = {
  CALL_UPDATE: 'callUpdate',
};

export const TelephonySignalREventType = {
  REQUEST_PING: 'RequestPing',
  UPDATE_CONTACT_STATUS: 'UpdateContactStatus',
  INCOMING_LEAD: 'IncomingLead',
  CANCEL_NOTIFICATION: 'CancelNotification',
  ON_TEXT_MESSAGE_RECEIVED: 'OnTextMessageReceived',
  JOIN_CONFERENCE: 'JoinConference',
  CONFERENCE_PARTICIPANT_JOINING: 'ConferenceParticipantJoining',
  CONFERENCE_PARTICIPANT_JOINED: 'ConferenceParticipantJoined',
  ON_WEB_CHAT_MESSAGE_RECEIVED: 'OnWebChatMessageReceived',
  ON_CALL_FAILED: 'OnCallFailed',
  ON_VOICEMAIL_RECEIVED: 'OnVoicemailReceived',
};

export const TelephonySignalRMessageType = {
  PING: 'Ping',
};

export const LEAD_NOTIFICATION_TIMEOUT_MS = 120_000;

export const HALF_HOUR_IN_MS = 1800000;
export const TOKEN_REFRESH_INTERVAL_MS = HALF_HOUR_IN_MS / 2;

export const TELNYX_SIP_DOMAIN = 'sip.telnyx.com';

// POST /api/telnyx/session { sessionId, kind } (DEV-6051) — one endpoint mints a per-session
// WebRTC credential for both surfaces; `kind` tells the backend which reap/expiry policy applies
// (24h expiry + 35-min staleness for web tabs, 60-day reap with no expiry for native devices).
export const TelephonySessionKind = {
  WEB: 'web',
  MOBILE_DEVICE: 'mobileDevice',
};
